import { ChartService } from "./chart.service";
import { type StablecoinLatestDO } from "../models/pie-chart.models";
import { type BubbleDO } from "../models/bubble.models";

export class BubbleChartService {
  constructor(private chartService: ChartService) { }

  async loadBubbleDefiTradfiTVL(): Promise<BubbleDO> {
    return this.chartService.load("bubble_defi_vs_tradfi_tvl");
  }

  async loadStablecoinVsBanks(): Promise<StablecoinLatestDO> {
    return this.chartService.load(`/latest/stablecoins`);
  }
}
